export default "__VITE_ASSET__nIIi5WPi__"